import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import NavDropdown from 'react-bootstrap/NavDropdown';
import Navbar from 'react-bootstrap/Navbar';
import LogoMortara from '../img/logo-mortara.png'
import { Offcanvas } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import { useState } from 'react';

function Menu() {

  const [show, setShow] = useState(false);
  

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true)
  return (
      <>
      {["xxl"].map((expand) => (
        <Navbar expand={expand} bg="light" className="Navbar mb-3" fixed="top">
          <Container fluid>
            <Navbar.Brand href="/" className="Logo"><img src={LogoMortara} alt="" /></Navbar.Brand>
            <Navbar.Toggle aria-controls={`offcanvasNavbar-expand-${expand}`} onClick={handleShow}/>
            <Navbar.Offcanvas show={show} onHide={handleClose}
              id={`offcanvasNavbar-expand-${expand}`}
              aria-labelledby={`offcanvasNavbarLabel-expand-${expand}`}
              placement="end"
            >
              <Offcanvas.Header>
                <Offcanvas.Title id={`offcanvasNavbarLabel-expand-${expand}`} className="Logo">
                  <img src={LogoMortara} alt="" />
                </Offcanvas.Title>
                <Button bsPrefix="closeBtn" onClick={handleClose}>
                  <i className="ri-close-line"></i>
                </Button>
              </Offcanvas.Header>
              <Offcanvas.Body>
                <Nav className="justify-content-end flex-grow-1 pe-5">
                  <Nav.Link href="/">Beranda</Nav.Link>
                  <Nav.Link href="/aboutus">Tentang Kami</Nav.Link>
                  <Nav.Link href="/portfolio">Portfolio</Nav.Link>
                  <Nav.Link href="/article">Artikel</Nav.Link>
                  {/* <Nav.Link href="/contact">Kontak</Nav.Link> */}
                  <NavDropdown
                    id="nav-dropdown-dark-example"
                    title="Kontak"
                    menuVariant="light"
                    className="dropdown"
                  >
                    <NavDropdown.Item href="https://api.whatsapp.com/send/?phone=6281223492192&text=Halo%2C+saya+ingin+menanyakan+detail+Mortara&type=phone_number&app_absent=0" target="_blank" rel="noreferrer">Whatsapp</NavDropdown.Item>
                    <NavDropdown.Item href="mailto:info@mortara.id" target="_blank" rel="noreferrer">Email</NavDropdown.Item>
                    <NavDropdown.Item href="https://www.instagram.com/mortara.id/" target="_blank" rel="noreferrer">Instagram</NavDropdown.Item>
                    {/* <NavDropdown.Divider /> */}
                  </NavDropdown>
                </Nav>
              </Offcanvas.Body>
            </Navbar.Offcanvas>
          </Container>
        </Navbar>
        ))}
      </>
    )
}

export default Menu;